export const maskIban = (iban: string) => {
  return '**** ' + iban.slice(-4);
};
